import React from "react"
import cal from "clsx"
import Tooltip from "@material-ui/core/Tooltip"
import CloseIcon from "@material-ui/icons/Close"
import { PresetBoard } from "Types/board"
import { useContentItem } from "Components/Preset/ContentItem/hook"
import { useContentItemStyle } from "Components/Preset/ContentItem/style"
import { WeekDay } from "Components/Preset/context"
import { PresetPlace } from "Types/place"
export interface ComponentProps {
    content: PresetBoard,
    weekDay: WeekDay,
    place: PresetPlace,
}
export default (props: ComponentProps) => {
    const classes = useContentItemStyle()
    const {
        backgroundColor, text, tooltip,
        showDeleteIcon, handleMouseEnter, handleMouseLeave,
        onDelete, handleEditPreset,
    } = useContentItem(props)
    return (
        <Tooltip placement="top" title={tooltip}>
            <div
                className={classes.root}
                style={{ backgroundColor }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={handleEditPreset}
            >
                { text }
                <CloseIcon
                    className={cal(
                        classes.icon,
                        showDeleteIcon && classes.iconShow,
                    )}
                    fontSize="small"
                    onClick={async (event: React.MouseEvent) => {
                        event.stopPropagation()
                        await onDelete()
                    }}
                />
            </div>
        </Tooltip>
    )
}

